// Singular — matches the BE @Controller("key-person").
export const KEY_PERSONS_ROUTE = 'key-person';
